var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useMemo, useState } from 'react';
import { translate } from '@utils/i18n';
import TextInput from '@components/TextInput/TextInput';
import { SelectInput } from '@ui/molecules/inputs/form/SelectInput/SelectInput';
import Brushaway from '../../../../components/Brushaway';
import { namespace } from './constants';
import '../../FormLibrary/styles.scss';
function ExternalFormDetail({ form, onClose, onSubmit, frequencies, hasWorkOrderForms, isInspectpointUser, territories }) {
    var _a, _b, _c, _d;
    const [editForm, setEditForm] = useState(form);
    useEffect(() => {
        if (form) {
            setEditForm(Object.assign(Object.assign({}, form), { visitType: !hasWorkOrderForms ? 'inspection' : form.visitType, frequencyIds: (form === null || form === void 0 ? void 0 : form.hasAllFrequencies) ? frequencies.map((f) => f.value) : (form === null || form === void 0 ? void 0 : form.frequencyIds) || [] }));
        }
    }, [form]);
    const handleSubmitForm = () => __awaiter(this, void 0, void 0, function* () {
        if (editForm) {
            return onSubmit(Object.assign(Object.assign({}, editForm), { hasAllFrequencies: allSelected, frequencyIds: allSelected ? [] : editForm.frequencyIds }));
        }
        return false;
    });
    const onChangeFrequency = (frequency) => {
        if (editForm) {
            if (editForm.frequencyIds.includes(frequency.value)) {
                setEditForm(Object.assign(Object.assign({}, editForm), { frequencyIds: editForm.frequencyIds.filter((id) => id !== frequency.value) }));
            }
            else {
                setEditForm(Object.assign(Object.assign({}, editForm), { frequencyIds: [...editForm.frequencyIds, frequency.value] }));
            }
        }
    };
    const allSelected = useMemo(() => {
        return (editForm === null || editForm === void 0 ? void 0 : editForm.frequencyIds.length) === frequencies.length;
    }, [frequencies, editForm === null || editForm === void 0 ? void 0 : editForm.frequencyIds]);
    const onSelectAllClicked = () => {
        if (editForm) {
            if (allSelected) {
                setEditForm(Object.assign(Object.assign({}, editForm), { frequencyIds: [] }));
            }
            else {
                setEditForm(Object.assign(Object.assign({}, editForm), { frequencyIds: frequencies.map((f) => f.value) }));
            }
        }
    };
    const handleNameChange = (event) => {
        if (editForm) {
            setEditForm(Object.assign(Object.assign({}, editForm), { displayName: event.target.value }));
        }
    };
    const handleActiveChange = (event) => {
        if (editForm) {
            setEditForm(Object.assign(Object.assign({}, editForm), { active: event.target.checked }));
        }
    };
    const visitTypeOptions = useMemo(() => {
        const options = [
            { value: 'inspection', label: translate('visit_types.inspection', { namespace }) }
        ];
        if (hasWorkOrderForms) {
            options.push({ value: 'service_visit', label: translate('visit_types.service_visit', { namespace }) }, { value: 'both', label: translate('visit_types.both', { namespace }) });
        }
        return options;
    }, [hasWorkOrderForms]);
    const handleVisitTypeChange = (value) => {
        if (editForm) {
            setEditForm(Object.assign(Object.assign({}, editForm), { visitType: value }));
        }
    };
    const handleAutoIncludeChange = (event) => {
        if (editForm) {
            setEditForm(Object.assign(Object.assign({}, editForm), { autoInclude: event.target.checked }));
        }
    };
    const handleExcludeFromReportsChange = (event) => {
        if (editForm) {
            setEditForm(Object.assign(Object.assign({}, editForm), { excludeFromReports: event.target.checked }));
        }
    };
    const handleTerritoryChange = (values) => {
        if (editForm) {
            setEditForm(Object.assign(Object.assign({}, editForm), { territoryIds: values }));
        }
    };
    const handlePdfFileNameChange = (event) => {
        if (editForm) {
            setEditForm(Object.assign(Object.assign({}, editForm), { pdfFileName: event.target.value }));
        }
    };
    return (React.createElement(Brushaway, { open: form !== null, title: translate('edit_title', { namespace }), isForm: true, onClose: () => {
            onClose();
        }, onSubmit: handleSubmitForm },
        React.createElement("div", { className: "form-edit-container" },
            React.createElement("div", { className: "form-section" },
                React.createElement(TextInput, { id: "name", value: editForm === null || editForm === void 0 ? void 0 : editForm.displayName, label: translate('name_label', { namespace }), onChange: handleNameChange }),
                React.createElement("label", { className: "qmb-checkbox mb-1" },
                    React.createElement("input", { type: "checkbox", checked: editForm === null || editForm === void 0 ? void 0 : editForm.active, onChange: handleActiveChange }),
                    React.createElement("p", { className: "qmb-checkbox-label", style: { padding: 0 } },
                        React.createElement("span", { className: "qmb-checkbox-title" }, 'Active'))),
                React.createElement("div", { className: "mt-3" },
                    React.createElement(SelectInput, { label: translate('visit_type_label', { namespace }), options: visitTypeOptions, value: (_a = editForm === null || editForm === void 0 ? void 0 : editForm.visitType) !== null && _a !== void 0 ? _a : 'inspection', onChange: handleVisitTypeChange })),
                territories.length > 0 && (React.createElement("div", { className: "mt-3" },
                    React.createElement(SelectInput, { label: translate('territories_label', { namespace }), options: territories, values: (editForm === null || editForm === void 0 ? void 0 : editForm.territoryIds) || [], onMultiChange: handleTerritoryChange, multiple: true, showSearch: true, displayMode: "labels", className: "mb-1" }),
                    React.createElement("small", { className: "note-section" },
                        React.createElement("i", { className: "fa fa-light fa-circle-info mr-1" }),
                        translate('territories_hint', { namespace })))),
                hasWorkOrderForms && (React.createElement("label", { className: "qmb-checkbox mt-3" },
                    React.createElement("input", { type: "checkbox", checked: (_b = editForm === null || editForm === void 0 ? void 0 : editForm.autoInclude) !== null && _b !== void 0 ? _b : false, onChange: handleAutoIncludeChange }),
                    React.createElement("p", { className: "qmb-checkbox-label", style: { padding: 0 } },
                        React.createElement("span", { className: "qmb-checkbox-title" }, translate('auto_include_label', { namespace }))))),
                React.createElement("label", { className: "qmb-checkbox mt-3" },
                    React.createElement("input", { type: "checkbox", checked: (_c = editForm === null || editForm === void 0 ? void 0 : editForm.excludeFromReports) !== null && _c !== void 0 ? _c : false, onChange: handleExcludeFromReportsChange }),
                    React.createElement("p", { className: "qmb-checkbox-label", style: { padding: 0 } },
                        React.createElement("span", { className: "qmb-checkbox-title" }, translate('exclude_from_reports_label', { namespace })))),
                React.createElement("small", { className: "note-section" },
                    React.createElement("i", { className: "fa fa-light fa-circle-info mr-1" }),
                    translate('exclude_from_reports_hint', { namespace })),
                isInspectpointUser && (React.createElement("div", { className: "mt-3" },
                    React.createElement(TextInput, { id: "pdfFileName", value: (_d = editForm === null || editForm === void 0 ? void 0 : editForm.pdfFileName) !== null && _d !== void 0 ? _d : '', label: "PDF File Name (S3)", onChange: handlePdfFileNameChange }))),
                React.createElement("div", { className: "mt-3" },
                    translate('select_intervals', { namespace }),
                    ":"),
                React.createElement("div", { className: "qmb-checkbox" },
                    React.createElement("input", { className: "qmb-checkbox__input", type: "checkbox", id: "frequency-select-all", checked: allSelected, onChange: () => onSelectAllClicked() }),
                    React.createElement("label", { htmlFor: "frequency-select-all" }, translate('select_all', { namespace }))),
                frequencies.map((frequency) => (React.createElement("div", { key: frequency.value, className: "qmb-checkbox" },
                    React.createElement("input", { className: "qmb-checkbox__input", type: "checkbox", id: `frequency-${frequency.value}`, checked: (editForm === null || editForm === void 0 ? void 0 : editForm.frequencyIds.includes(frequency.value)) || false, onChange: () => onChangeFrequency(frequency) }),
                    React.createElement("label", { htmlFor: `frequency-${frequency.value}` }, frequency.label))))),
            React.createElement("div", { className: "note-section" }, translate('edit_detail_note', { namespace, inspections: form === null || form === void 0 ? void 0 : form.inspectionsCount })))));
}
export default ExternalFormDetail;
